<p-toast></p-toast>
<div class="h-full w-full">
    <div class="grid flex justify-content-center">
        <div class="col-8">
            <div class="grid">
                <div class="col-12" *ngIf="!loadingSearchOption; else spinner">
                    <form [formGroup]="reportForm" autocomplete="off">
                        <div class="grid mt-5 flex justify-content-center">
                            <div class="col-4">
                                <span class="p-float-label">
                                    <p-dropdown [options]="primaryReportOptions" formControlName="primaryOption"
                                        [(ngModel)]="selectedPrimaryReportOption" optionLabel="name" optionValue="code"
                                        appendTo="body" (onChange)="stepChanged(1)" placeholder="Select Report Name"
                                        styleClass="w-full">
                                    </p-dropdown>
                                    <label>Report Name</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid mt-5 flex justify-content-center" *ngIf="selectedPrimaryReportOption">
                            <div class="col-4">
                                <span class="p-float-label">
                                    <p-dropdown [options]="secondaryReportOptions" formControlName="secondaryOption"
                                        [(ngModel)]="selectedSecondaryReportOption" optionLabel="name"
                                        optionValue="code" placeholder="Select Search Criteria" appendTo="body"
                                        [disabled]="loadingSearchOption" (onChange)="stepChanged(2)"
                                        styleClass="w-full">
                                    </p-dropdown>
                                    <label>Search Criteria</label>
                                </span>
                            </div>
                        </div>

                        <div class="grid mt-5 flex justify-content-center" *ngIf="selectedSecondaryReportOption">
                            <div class="col-4 p-0 m-0">
                                <div class="col-12 p-0 m-0" *ngIf="!loadingSearchOption; else spinner">
                                    <div class="grid p-0 m-0">
                                        <div *ngIf="selectedSecondaryReportOption == 'suite' || selectedSecondaryReportOption == 'account'"
                                            [ngClass]="selectedSecondaryReportOption == 'suite'? 'col-12' : 'col-12'">
                                            <span class="p-float-label">
                                                <p-dropdown [options]="suiteOptions" formControlName="suite"
                                                    [(ngModel)]="selectedSuite" optionLabel="name" optionValue="code"
                                                    appendTo="body" placeholder="Select Suite"
                                                    (onChange)="getAccountBySuite()" styleClass="w-full">
                                                </p-dropdown>
                                                <label>Suite</label>
                                            </span>
                                        </div>

                                        <div class="col-12 mt-5" *ngIf="selectedSecondaryReportOption == 'account'">
                                            <span class="p-float-label">
                                                <p-dropdown [options]="suiteAcctOptions" formControlName="account"
                                                    [(ngModel)]="selectedSuiteAcct" optionLabel="name"
                                                    optionValue="code" appendTo="body" styleClass="w-full">
                                                </p-dropdown>
                                                <label>Account</label>
                                            </span>
                                        </div>

                                        <div class="col-12" *ngIf="selectedSecondaryReportOption == 'billing_period'">
                                            <span class="p-float-label">
                                                <p-calendar formControlName="billing_period"
                                                    [(ngModel)]="selectedBillingMonth" view="month" [minDate]="minDate"
                                                    [maxDate]="maxDate" dateFormat="mm/yy" [readonlyInput]="true"
                                                    placeholder="Billing Month/Year" styleClass="w-full"></p-calendar>
                                                <label>Billing Period</label>
                                            </span>
                                        </div>

                                        <div class="col-12"
                                            *ngIf="selectedSecondaryReportOption == 'invoice_date' || selectedSecondaryReportOption == 'payment_date' || selectedSecondaryReportOption == 'posted_on'">
                                            <span class="p-float-label"
                                                *ngIf="selectedSecondaryReportOption == 'invoice_date'">
                                                <p-calendar formControlName="invoice_date"
                                                    [(ngModel)]="selectedInvoiceRangeDates" [showIcon]="true"
                                                    [maxDate]="maxDate" selectionMode="range" [readonlyInput]="true"
                                                    placeholder="Date" styleClass="w-full"></p-calendar>
                                                <label *ngIf="selectedPrimaryReportOption != 'Termination List'">Invoice Date Period</label>
                                                <label *ngIf="selectedPrimaryReportOption == 'Termination List'">Date Period</label>
                                            </span>
                                            <span class="p-float-label"
                                                *ngIf="selectedSecondaryReportOption == 'payment_date'">
                                                <p-calendar formControlName="payment_date"
                                                    [(ngModel)]="selectedPaymentRangeDates" [showIcon]="true"
                                                    [maxDate]="maxDate" selectionMode="range" [readonlyInput]="true"
                                                    placeholder="Date" styleClass="w-full"></p-calendar>
                                                <label>Payment Date Period</label>
                                            </span>

                                            <span class="p-float-label"
                                                *ngIf="selectedSecondaryReportOption == 'posted_on'">
                                                <p-calendar formControlName="posted_on"
                                                    [(ngModel)]="selectedPostedOnRangeDates" [showIcon]="true"
                                                    [maxDate]="maxDate" selectionMode="range" [readonlyInput]="true"
                                                    placeholder="Date" styleClass="w-full"></p-calendar>
                                                <label>Posted Date Period</label>
                                            </span>

                                        </div>

                                        <div class="col-12" *ngIf="selectedSecondaryReportOption == 'invoice_status'">
                                            <span class="p-float-label">
                                                <p-dropdown formControlName="invoice_status"
                                                    [options]="invoiceStatusOptions"
                                                    optionLabel="name" optionValue="code" appendTo="body" placeholder="Select Invoice Status"
                                                    styleClass="w-full">
                                                </p-dropdown>
                                                <label>Invoice Status</label>
                                            </span>
                                        </div>

                                        <div class="col-12" *ngIf="selectedSecondaryReportOption == 'as_of_date'">
                                            <span class="p-float-label">
                                                <p-calendar formControlName="as_of_date" [(ngModel)]="selectedDate"
                                                    [showIcon]="true" [maxDate]="maxDate" placeholder="Date"
                                                    [readonlyInput]="true" styleClass="w-full"></p-calendar>
                                                <label>As of Date</label>
                                            </span>
                                        </div>

                                        <div class="col-12" *ngIf="selectedSecondaryReportOption == 'active_only'">
                                            <span class="flex align-items-center gap-1 mt-3">
                                                <p-checkbox formControlName="active_only" [(ngModel)]="activeOnly"
                                                    [binary]="true"></p-checkbox>
                                                <label>Active Accounts Only</label>
                                            </span>
                                            <p>Uncheck to show inactive accounts.</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid mt-5 flex justify-content-center">
                            <div class="col-3 flex justify-content-center">
                                <p-button label="Run this report" icon="pi pi-arrow-right" iconPos="right"
                                    (onClick)="generateReport()" [disabled]="reportForm.invalid" [loading]="reportInProgress"/>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #spinner>
    <p-progressSpinner></p-progressSpinner>
</ng-template>